import React, {useState} from 'react';
import {StyleSheet, TouchableOpacity, View} from 'react-native';
import * as Clipboard from 'expo-clipboard';
import {FontAwesomeIcon} from '@fortawesome/react-native-fontawesome';
import {faCheck, faCopy} from '@fortawesome/free-solid-svg-icons';
import Colors from '../constants/Colors';
import {Text} from './Themed';

export default function CopyResponseButton({content}: {content: string}) {
  const [status, setStatus] = useState<'idle' | 'copying' | 'copied' | 'error'>('idle');

  const copy = async () => {
    if (status === 'copying') return;
    setStatus('copying');
    try {
      const copied = await Clipboard.setStringAsync(content);
      setStatus(copied ? 'copied' : 'error');
    } catch {
      setStatus('error');
    }
  };

  return <View style={styles.toolbar}>
    {(status === 'copied' || status === 'error') &&
      <Text accessibilityLiveRegion="polite" style={styles.feedback}>
        {status === 'copied' ? 'Copied' : 'Could not copy. Try again.'}
      </Text>}
    <TouchableOpacity
      accessibilityRole="button"
      accessibilityLabel="Copy Markdown source"
      accessibilityHint="Copies the original response source to the clipboard."
      accessibilityState={{disabled: status === 'copying', busy: status === 'copying'}}
      disabled={status === 'copying'}
      onPress={copy}
      style={styles.button}>
      <FontAwesomeIcon icon={status === 'copied' ? faCheck : faCopy} color={Colors.dark.text} size={18}/>
    </TouchableOpacity>
  </View>;
}

const styles = StyleSheet.create({
  toolbar: {flexDirection: 'row', justifyContent: 'flex-end', alignItems: 'center', marginBottom: 4},
  button: {width: 44, height: 44, alignItems: 'center', justifyContent: 'center', borderRadius: 6},
  feedback: {fontSize: 14, marginRight: 8, flexShrink: 1},
});
